<template>
  <div>
    <el-row>
      <el-card :body-style="cardBodyStyle">
        <el-form ref="form" :model="form" :rules="formRules" label-width="80px" :inline="true">
          <el-form-item class="no-show-error-message" label="表名" prop="tableName">
            <el-input v-model="form.tableName" size="small" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item class="no-show-error-message" label="表名前缀" prop="tablePrefix">
            <el-input v-model="form.tablePrefix" size="small" placeholder="T_TEST" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item class="no-show-error-message" label="服务名" prop="moduleName">
            <el-input v-model="form.moduleName" size="small" placeholder="test" style="width: 200px;"
              @input="handleModuleNameInput">
            </el-input>
          </el-form-item>
          <el-form-item class="no-show-error-message" label="包名" prop="parentPackageName">
            <el-input v-model="form.parentPackageName" size="small" placeholder="com.shinsoft.servicetest"
              style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item class="no-show-error-message" label="微服务名" prop="serviceName">
            <el-input v-model="form.serviceName" size="small" placeholder="service-test" style="width: 200px;">
            </el-input>
          </el-form-item>
          <el-form-item class="no-show-error-message" label="流程挂载" prop="vuePath">
            <el-input v-model="form.processName" size="small" style="width: 200px;">
              <el-button slot="append" icon="el-icon-search" size="mini" @click="handlePopupProcess"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item class="no-show-error-message" label="vue路径" prop="vuePath">
            <el-input v-model="form.vuePath" size="small" placeholder="C:\workspaces\sgiip\Proj_SgIIP_Src_vue"
              style="width: 500px;">
            </el-input>
          </el-form-item>
          <el-form-item class="no-show-error-message" label="建表">
            <el-checkbox v-model="form.tableFlag"></el-checkbox>
          </el-form-item>
          <el-form-item class="no-show-error-message" label="代码">
            <el-checkbox v-model="form.codeFlag"></el-checkbox>
          </el-form-item>
          <el-form-item class="no-show-error-message" label="">
            <el-button size="mini" type="success" @click="handleGenerate('form')">生成</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-row>

    <el-row :gutter="5">
      <el-col :span="layoutLeft">
        <el-card :body-style="cardBodyStyle">
          <el-button size="mini" type="success" @click="handleColumnAdd( )">新增</el-button>
          <el-button size="mini" @click="clearFilter">清除过滤</el-button>
          </el-card >
            <el-card :body-style="cardBodyStyle">

          <el-table :data="tableData" ref="tableData" border highlight-current-row @row-click="handleRowClick" height="650px">
            <el-table-column prop="sort" type="index" label="序号" align="center" width="60"  >
            </el-table-column>
            <!--            <el-table-column prop="id" label="id" width="60" header-align="center" align="center" show-overflow-tooltip>
            </el-table-column> -->

            <el-table-column prop="columnName" label="字段名" width="140" header-align="center" align="center"
              show-overflow-tooltip >
            </el-table-column>
            <el-table-column prop="comment" label="注释/表头" width="140" header-align="center" align="center"
              show-overflow-tooltip  >
            </el-table-column>
            <el-table-column label="数据库" header-align="center">
              <el-table-column prop="columnType" label="字段类型" width="140" header-align="center" align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="length" label="长度" width="80" header-align="center" align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="precision" label="精度" width="80" header-align="center" align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="nullFlag" label="非空" width="80" header-align="center" align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.nullFlag" disabled></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="pkFlag" label="主键" width="80" header-align="center" align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.pkFlag" disabled></el-checkbox>
                </template>
              </el-table-column>

            </el-table-column>
            <el-table-column label="列表" header-align="center">
              <el-table-column prop="showFlag" label="显示" width="80" header-align="center" align="center"
                show-overflow-tooltip :filters="[{text: '是', value: true}, {text: '否', value: false }]"
                :filter-method="filterHandler">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.showFlag" disabled></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="width" label="列宽" width="80" header-align="center" align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="align" label="对齐" width="80" header-align="center" align="center"
                show-overflow-tooltip
                :filters="[{text: '左对齐', value: 'left'}, {text: '居中', value: 'center' }, {text: '右对齐', value: 'right' }]"
                :filter-method="filterHandler">
              </el-table-column>
            </el-table-column>
            <el-table-column label="表单" header-align="center">

              <el-table-column prop="controllerType" label="控件" width="120" header-align="center" align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="inputFlag" label="录入" width="80" header-align="center" align="center"
                show-overflow-tooltip :filters="[{text: '是', value: true}, {text: '否', value: false }]"
                :filter-method="filterHandler">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.inputFlag" disabled></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="requireFlag" label="必填" width="80" header-align="center" align="center"
                show-overflow-tooltip>
                <template slot-scope="scope" :filters="[{text: '是', value: true}, {text: '否', value: false }]"
                  :filter-method="filterHandler">
                  <el-checkbox v-model="scope.row.requireFlag" disabled></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="查询" header-align="center">
              <el-table-column prop="queryFlag" label="条件" width="80" header-align="center" align="center"
                show-overflow-tooltip :filters="[{text: '是', value: true}, {text: '否', value: false }]"
                :filter-method="filterHandler">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.queryFlag" disabled></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="fuzzyFlag" label="模糊" width="80" header-align="center" align="center"
                show-overflow-tooltip :filters="[{text: '是', value: true}, {text: '否', value: false }]"
                :filter-method="filterHandler">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.fuzzyFlag" disabled></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="dateFlag" label="范围" width="80" header-align="center" align="center"
                show-overflow-tooltip :filters="[{text: '是', value: true}, {text: '否', value: false }]"
                :filter-method="filterHandler">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.dateFlag" disabled></el-checkbox>
                </template>
              </el-table-column>

            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="80px">
              <template slot-scope="scope">
                <el-button size="mini" plain @click="handleColumnRemove(scope.row,scope.$index )">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

      </el-col>
      <el-col :span="layoutRight">
        <el-card :body-style="cardBodyStyle">
        <el-button size="mini" type="danger" @click="handleCollspan( )">收起</el-button>
        <el-button size="mini" type="danger" @click="handleColumnClean( )">清空</el-button>
        </el-card  >
          <el-card :body-style="cardBodyStyle">
       <!-- <el-input v-model="column.id" size="small"></el-input> -->
        <el-form ref="column" :model="column" label-width="80px" :inline="true">
          <el-collapse v-model="activeNames">
            <el-collapse-item title=" 表" name="1">
              <el-form-item label="字段名">
                <el-input v-model="column.columnName" size="small" class="sx-formitem-width"></el-input>
              </el-form-item>
              <el-form-item label="非空">
                <el-checkbox v-model="column.nullFlag"></el-checkbox>
              </el-form-item>
              <el-form-item label="主键">
                <el-checkbox v-model="column.pkFlag"></el-checkbox>
              </el-form-item>
              <el-row>
                <el-form-item label="字段类型">
                  <el-select v-model="column.columnType" size="small" class="sx-formitem-width"
                    @change="columnTypeChange">
                    <el-option v-for="item in columnTypeOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="长度">
                  <el-input-number v-model="column.length" :min="0" size="small" style="width: 120px;">
                  </el-input-number>
                </el-form-item>
                <el-form-item label="精度">
                  <el-input-number v-model="column.precision" :min="0" size="small" style="width: 120px;">
                  </el-input-number>
                </el-form-item>
              </el-row>
              <el-form-item label="注释/表头">
                <el-input v-model="column.comment" size="small" class="sx-formitem-width" placeholder="">
                </el-input>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item title=" 表格" name="2">
              <el-form-item label="显示">
                <el-checkbox v-model="column.showFlag"></el-checkbox>
              </el-form-item>
              <el-form-item label="列宽">
                <el-input v-model="column.width" size="small" style="width: 80px;" clearable></el-input>
              </el-form-item>
              <el-form-item label="对齐">
                <el-select v-model="column.align" size="small" style="width: 100px;">
                  <el-option v-for="item in controllerAlignOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>


            </el-collapse-item>
            <el-collapse-item title=" 表单" name="3">
              <el-form-item label="控件类型">
                <el-select v-model="column.controllerType" size="small" class="sx-formitem-width"
                  @change="controllerTypeChange">
                  <el-option v-for="item in controllerTypeOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="录入">
                <el-checkbox v-model="column.inputFlag"></el-checkbox>
              </el-form-item>
              <el-form-item label="必填">
                <el-checkbox v-model="column.requireFlag"></el-checkbox>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item title=" 查询条件" name="4">
              <el-form-item label="查询条件">
                <el-checkbox v-model="column.queryFlag"></el-checkbox>
              </el-form-item>
              <el-form-item label="模糊查询" v-if="fuzzyFlagVisible">
                <el-checkbox v-model="column.fuzzyFlag"></el-checkbox>
              </el-form-item>
              <el-form-item label="日期范围" v-if="dateFlagVisible">
                <el-checkbox v-model="column.dateFlag"></el-checkbox>
              </el-form-item>
            </el-collapse-item>
          </el-collapse>
        </el-form>
         </el-card  >
      </el-col>
    </el-row>



    <popup-process ref="PopupProcess" v-on:receiveFromChild="receiveFromPopupProcess"></popup-process>
  </div>
</template>

<script>
  import axios from '@/axios'
  import tools from '@/tools'
  import date from '@/tools/date.js'
  import PopupProcess from '@/components/system/PopupProcess.vue'
  export default {
    components: {
      PopupProcess
    },

    data() {

      return {
        cardBodyStyle: tools.style.card,
        layoutLeft: 24,
        layoutRight: 0,
        activeNames: ['1', '2', '3', '4'],
        form: {
          tableName: 'T_TEST_LEE',
          tablePrefix: 'T_TEST',
          processName: '',
          processKey: '',
          tableFlag: false,
          codeFlag: true,
        },
        column: {
          id: '',
          sort: 0,
          columnName: '',
          nullFlag: false,
          pkFlag: false,
          columnType: '',
          length: 0,
          precision: 0,
          comment: '',

          showFlag: false,
          width: 60,
          align: 'center',
          width: 0,
          align: 'center',

          controllerType: '',
          inputFlag: false,
          requireFlag: false,

          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,

        },

        columnTypeOptions: [{
          value: 'varchar',
          label: 'varchar'
        }, {
          value: 'int',
          label: 'int'
        }, {
          value: 'double',
          label: 'double'
        }, {
          value: 'date',
          label: 'date'
        },  {
          value: 'datetime',
          label: 'datetime'
        }],

        controllerTypeOptions: [{
          value: '单行文本',
          label: '单行文本'
        }, {
          value: '多行文本',
          label: '多行文本'
        }, {
          value: '下拉',
          label: '下拉'
        }, {
          value: '日期',
          label: '日期'
        }, {
          value: '日期时间',
          label: '日期时间'
        }],
        controllerAlignOptions: [{
          value: 'left',
          label: '左对齐'
        }, {
          value: 'center',
          label: '居中'
        }, {
          value: 'right',
          label: '右对齐'
        }],
        formRules: {
          tableName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          tablePrefix: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          moduleName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          serviceName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          parentPackageName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          vuePath: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
        },
        fuzzyFlagVisible: true,
        dateFlagVisible: true,
        tableData: []
      }
    },
    methods: {
      handleModuleNameInput(value) {

        this.form.parentPackageName = 'com.yuanxi.' + value
        this.form.serviceName =   value

      },
      handleColumnAdd() {
        this.handleColumnClean()
        this.column = {
          id: '',
          sort: this.tableData.length,
          showFlag: true,
          width: 60,
          align: 'center',
          requireFlag: true,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          inputFlag: true,
          length: 0,
          precision: 0,
          width: 0,
        }
        this.tableData.push(this.column)
        this.$refs.tableData.setCurrentRow(this.tableData[this.tableData.length - 1])
        this.layoutLeft = 12
        this.layoutRight = 12

      },
      handleColumnRemove(row, index) {
        this.$refs.tableData.setCurrentRow()
        this.tableData.splice(index, 1)
      },
      handleColumnClean() {
        this.column = {
          id: '',
          columnName: '',
          nullFlag: false,
          pkFlag: false,
          columnType: '',
          comment: '',
          controllerType: '',
          showFlag: false,
          width: 60,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          inputFlag: true,
          length: 0,
          precision: 0,
          width: 0,
        }
      },

      handleRowClick(row) {
        this.column = row
        this.layoutLeft = 12
        this.layoutRight = 12
      },
      handleCollspan() {
        this.layoutLeft = 24
        this.layoutRight = 0
      },
      handleGenerate(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            var url = this.form.moduleName + '/Generate/generate.do'
            var param = {
              jsonForm: JSON.stringify(this.form),
              jsonFileds: JSON.stringify(this.tableData)
            }
            axios.post(url, param).then(response => {
              this.$message({
                type: 'success',
                message: 'success!',
              });
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },

      columnTypeChange(value) {
        var len = 0
        if (this.column.comment) {
          len = this.column.comment.length
        } else {
          len = 2
        }
        if (value == 'varchar') {
          this.column.width = this.column.width ? this.column.width : len * 30
          this.column.align = 'center'
          this.fuzzyFlagVisible = true
          this.dateFlagVisible = false
        } else if (value == 'NUMBER') {
          this.column.width = this.column.width ? this.column.width : len * 30
          this.column.align = 'right'
          this.fuzzyFlagVisible = true
          this.dateFlagVisible = false
        } else if (value == 'datetime') {
          this.column.width = 100
          this.column.align = 'center'
          this.fuzzyFlagVisible = false
          this.dateFlagVisible = true
        }
      },
      controllerTypeChange(value) {


        if (value == '日期') {
          this.column.width = 100
        } else if (value == '日期时间') {
          this.column.width = 160
        }
      },
      filterHandler(value, row, column) {
        const property = column['property'];
        return row[property] === value;
      },
      clearFilter() {
        this.$refs.tableData.clearFilter();
      },
      handlePopupProcess() {
        this.$refs.PopupProcess.show()
      },
      receiveFromPopupProcess(value) {
        console.log(JSON.stringify(value))
        this.form.processKey = value.key
        this.form.processName = value.name
      },

    },
    mounted() {
      this.tableData = [{
          id: '',
          columnName: 'ID',
          nullFlag: true,
          pkFlag: true,
          columnType: 'varchar',
          length: 32,
          precision: 0,
          comment: '主键',

          showFlag: true,
          width: 60,
          align: 'center',
          width: 60,
          align: 'center',

          controllerType: '单行文本',
          inputFlag: false,
          requireFlag: false,

          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,

        }, {
          id: '',
          columnName: 'TEST',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '一行',
          inputFlag: true,
          controllerType: '单行文本',
          showFlag: true,
          width: 60,
          align: 'center',

          requireFlag: true,
          queryFlag: true,
          fuzzyFlag: true,
          dateFlag: false,
          length: 200,
          precision: 0,
        }, {
          id: '',
          columnName: 'TEST_AREA',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '两行',
          inputFlag: true,
          controllerType: '多行文本',
          showFlag: true,
          width: 60,
          align: 'left',

          requireFlag: true,
          queryFlag: true,
          fuzzyFlag: true,
          dateFlag: false,
          length: 200,
          precision: 0,
        }, {
          id: '',
          columnName: 'INPUT_INT',
          nullFlag: false,
          pkFlag: false,
          columnType: 'int',
          comment: '整数',
          inputFlag: true,
          controllerType: '单行文本',
          showFlag: true,
          width: 60,
          align: 'right',
          requireFlag: false,
          queryFlag: true,
          fuzzyFlag: true,
          dateFlag: false,
          length: 9,
          precision: 0,
        }, {
          id: '',
          columnName: 'INPUT_DOUBLE',
          nullFlag: false,
          pkFlag: false,
          columnType: 'double',
          comment: '小数',
          inputFlag: true,
          controllerType: '单行文本',
          showFlag: true,
          width: 60,
          align: 'right',
          requireFlag: false,
          queryFlag: true,
          fuzzyFlag: true,
          dateFlag: false,
          length: 15,
          precision: 3,
        },
        {
          id: '',
          columnName: 'INPUT_DATE',
          nullFlag: false,
          pkFlag: false,
          columnType: 'date',
          comment: '日期',
          inputFlag: true,
          controllerType: '日期',
          showFlag: true,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: true,
          fuzzyFlag: false,
          dateFlag: false,
          length: 0,
          precision: 0,
        }, {
          id: '',
          columnName: 'INPUT_DATETIME',
          nullFlag: false,
          pkFlag: false,
          columnType: 'datetime',
          comment: '日期时间',
          inputFlag: true,
          controllerType: '日期时间',
          showFlag: true,
          width: 160,
          align: 'center',
          requireFlag: false,
          queryFlag: true,
          fuzzyFlag: false,
          dateFlag: true,
          length: 0,
          precision: 0,
        }, {
          id: '',
          columnName: 'PROCESS_INSTANCE_ID',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '流程id',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: true,
          width: 60,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 50,
          precision: 0,
        }, {
          id: '',
          columnName: 'PROCESS_INSTANCE_STATUS',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '流程状态',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: true,
          width: 60,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 50,
          precision: 0,
        }, {
          id: '',
          columnName: 'ADD_ID',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '添加人id',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 32,
          precision: 0,
        }, {
          id: '',
          columnName: 'ADD_CODE',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '添加人编码',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 200,
          precision: 0,
        }, {
          id: '',
          columnName: 'ADD_NAME',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '添加人名称',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: true,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 200,
          precision: 0,
        }, {
          id: '',
          columnName: 'ADD_DEPT_CODE',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '添加部门编码',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 200,
          precision: 0,
        }, {
          id: '',
          columnName: 'ADD_DEPT_NAME',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '添加部门名称',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: true,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 200,
          precision: 0,
        }, {
          id: '',
          columnName: 'ADD_TIME',
          nullFlag: false,
          pkFlag: false,
          columnType: 'datetime',
          comment: '添加时间',
          inputFlag: false,
          controllerType: '日期时间',
          showFlag: true,
          width: 160,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 0,
          precision: 0,
        }, {
          id: '',
          columnName: 'MODIFY_ID',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '修改人id',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 32,
          precision: 0,
        }, {
          id: '',
          columnName: 'MODIFY_CODE',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '修改人编码',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 200,
          precision: 0,
        }, {
          id: '',
          columnName: 'MODIFY_NAME',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '修改人名称',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 200,
          precision: 0,
        }, {
          id: '',
          columnName: 'MODIFY_TIME',
          nullFlag: false,
          pkFlag: false,
          columnType: 'datetime',
          comment: '修改时间',
          inputFlag: false,
          controllerType: '日期时间',
          showFlag: false,
          width: 160,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 0,
          precision: 0,
        }, {
          id: '',
          columnName: 'CANCEL_ID',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '作废人id',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 32,
          precision: 0,
        }, {
          id: '',
          columnName: 'CANCEL_CODE',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '作废人编码',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 200,
          precision: 0,
        }, {
          id: '',
          columnName: 'CANCEL_NAME',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '作废人名称',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 100,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 200,
          precision: 0,
        }, {
          id: '',
          columnName: 'CANCEL_TIME',
          nullFlag: false,
          pkFlag: false,
          columnType: 'datetime',
          comment: '作废时间',
          inputFlag: false,
          controllerType: '日期时间',
          showFlag: false,
          width: 160,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 0,
          precision: 0,
        }, {
          id: '',
          columnName: 'CANCEL_FLAG',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '作废标记',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 60,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 1,
          precision: 0,
        }, {
          id: '',
          columnName: 'BELONG_ID',
          nullFlag: false,
          pkFlag: false,
          columnType: 'varchar',
          comment: '测试',
          inputFlag: false,
          controllerType: '单行文本',
          showFlag: false,
          width: 60,
          align: 'center',
          requireFlag: false,
          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
          length: 32,
          precision: 0,
        },
      ]
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/system/generator.vue